import * as types from './typeNames'


export const setSettings = (form, config, fromEditor = null) => ({
    type: types.SET_SETTINGS,
    form,
    fromEditor,
    config
})

export const resetSettings = (form, config, fromEditor = null) => ({
    type: types.RESET_SETTINGS,
    form,
    fromEditor,
    config
})

export const selectTab = (tab_id) => ({
    type: types.SELECT_TAB,
    tab_id
})

export const selectDefaultEditTab = () => ({
    type: types.SELECT_DEFAULT_EDIT_TAB
})

export const selectTemplate = (template) => ({
    type: types.SELECT_TEMPLATE,
    template
})

export const setFormName = name => ({
    type: types.SET_FORM_NAME,
    name
})

export const selectElementForAddingToForm = element => ({
    type: types.SELECT_ELEMENT_FOR_ADDING_TO_FORM,
    element
})

export const changeList = newList => ({
    type: types.CHANGE_FORM_ELEMENTS_LIST,
    elements: newList
})

export const changeOptionList = newList => ({
    type: types.CHANGE_FORM_OPTIONS_LIST,
    options: newList
})

export const addNewElement = elm => ({
    type: types.ADD_ELEMENT_TO_LIST,
    element: elm
})

export const editElement = elm => ({
    type: types.EDIT_ELEMENT,
    element: elm
})

export const addNewOption = () => ({
    type: types.ADD_OPTION_TO_LIST,
})

export const deleteElement = (element, listName, option) => ({
    type: types.DELETE_ELEMENT_FROM_LIST,
    element,
    listName,
    option
})

export const changeNameElement = (name, id, kind) => ({
    type: types.CHANGE_ELEMENT_NAME,
    name,
    id,
    kind
})

export const saveOptions = () => ({
    type: types.SAVE_OPTIONS    
})

export const changeOptionIsHalf = (flag) => ({
    type: types.CHANGE_FLAG,
    flag    
})

export const toggleIsRequiredOption = (flag) => ({
    type: types.CHANGE_ISREQUIRED_FLAG,
    flag
})